<template>
  <div>
    <v-card>
      <v-card-title class="title font-weight-regular justify-space-between">
        <span class="window-title">{{ currentTitle }}</span>
        <v-chip color="info" text-color="white" disabled>{{`Bước ${activeStep}/5`}}</v-chip>
      </v-card-title>

      <v-form v-model="form.isValid">
        <v-window v-model="activeStep">
          <v-window-item :value="1" color="red">
            <div class="window-content">
              <span>Vui lòng chọn một xe để tạo lịch bảo trì</span>
              <v-radio-group v-model="form.vehicleId" :rules="[validate.required]">
                <v-radio
                  v-for="vehicle in vehicles"
                  :key="vehicle.id"
                  :label="vehicle.plate"
                  :value="vehicle.id"
                ></v-radio>
              </v-radio-group>
            </div>
          </v-window-item>

          <v-window-item :value="2">
            <div class="window-content">
              <span>Vui lòng chọn một loại bảo trì có sẵn</span>
              <v-radio-group v-model="form.name" :rules="[validate.required]">
                <v-radio v-for="item in maintenanceType" :key="item" :label="item" :value="item"></v-radio>
                <v-radio label="Nhập vào một loại bảo trì" value="empty"></v-radio>
              </v-radio-group>
              <v-text-field
                label="Tên loại bảo trì"
                prepend-icon="build"
                color="info"
                :disabled="!display.typeNameInput"
                v-model="form.inputName"
                :error-messages="error.inputName"
              ></v-text-field>
            </div>
          </v-window-item>

          <v-window-item :value="3">
            <div class="window-content">
              <p>Thông thường các bộ phận của xe sẽ được bảo trì theo chu kỳ một khoảng thời gian hoặc một quãng đường đã đi. Bạn có thể kết hợp cả 2 cách trên, điều kiện nào đến trước sẽ được ưu tiên nhắc nhở trước</p>
              <span>
                <b>Theo chu kì thời gian</b>
              </span>
              <v-layout align-center class="min-top">
                <v-checkbox
                  v-model="form.dayBased"
                  :disabled="!form.kmBased"
                  hide-details
                  class="shrink mr-2"
                ></v-checkbox>
                <v-text-field
                  :disabled="!form.dayBased"
                  v-model="form.monthInterval"
                  mask="##"
                  suffix="tháng"
                  color="info"
                  :rules="[validate.required]"
                ></v-text-field>
              </v-layout>
              <span>
                <b>Theo quãng đường đã đi</b>
              </span>
              <v-layout align-center class="min-top">
                <v-checkbox
                  v-model="form.kmBased"
                  :disabled="!form.dayBased"
                  hide-details
                  class="shrink mr-2"
                ></v-checkbox>
                <v-text-field
                  :disabled="!form.kmBased"
                  v-model="form.kmInterval"
                  mask="#####"
                  suffix="km"
                  color="info"
                  :rules="[validate.required]"
                ></v-text-field>
              </v-layout>
            </div>
          </v-window-item>

          <v-window-item :value="4">
            <div class="window-content">
              <span>Bằng cách cung cấp cho hệ thống lần bảo trì gần nhất của bạn, hệ thống sẽ tính toán thời gian hợp lý cho lần bảo trì tiếp theo</span>
              <v-radio-group v-model="form.lastExecutionMonth" :rules="[validate.required]">
                <v-radio label="1 tháng trước" :value="1"></v-radio>
                <v-radio label="2 tháng trước" :value="2"></v-radio>
                <v-radio label="3 tháng trước" :value="3"></v-radio>
                <v-radio label="4 tháng trước" :value="4"></v-radio>
                <v-radio label="Chọn một ngày" :value="-1"></v-radio>
              </v-radio-group>
              <v-menu
                :close-on-content-click="false"
                v-model="display.lastExecutionMenu"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  label="Ngày bảo trì"
                  prepend-icon="calendar_today"
                  color="info"
                  v-model="form.lastExecutionDate"
                  :disabled="!display.lastExecutionInput"
                  :error-messages="error.lastExecutionDate"
                ></v-text-field>
                <v-date-picker
                  v-model="form.lastExecutionDate"
                  @input="display.lastExecutionMenu = false"
                ></v-date-picker>
              </v-menu>
            </div>
          </v-window-item>

          <v-window-item :value="5">
            <div class="window-content">
              <span>Dựa trên những thông tin bạn cung cấp, hệ thống đã tính toán lần bảo trì tiếp theo cho bạn
                <br>
                <br>
              </span>
              <v-text-field
                outline
                label="Ngày bảo trì tiếp theo"
                prepend-inner-icon="calendar_today"
                :suffix="`${form.nextMaintenanceDate} ${moment(form.nextMaintenanceDate) < moment() ? `(Quá hạn)` : ``}`"
                disabled
                :background-color="`${moment(form.nextMaintenanceDate) < moment() ? `red` : ``}`"
                v-if="form.dayBased"
              ></v-text-field>
              <v-text-field
                outline
                label="Số km còn lại"
                prepend-inner-icon="timeline"
                :suffix="`${form.kmRemain} km ${form.kmRemain < 0 ? `(Vượt mức)` : ``}`"
                disabled
                :background-color="`${form.kmRemain < 0 ? `red` : ``}`"
                v-if="form.kmBased"
              ></v-text-field>
              <v-text-field label="Ghi chú" prepend-icon="note" color="info" v-model="form.remark"></v-text-field>
            </div>
          </v-window-item>
        </v-window>
      </v-form>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn :disabled="activeStep === 1" flat @click="activeStep--">
          <v-icon>navigate_before</v-icon>Quay lại
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="info" depressed @click="next()" :loading="isLoading">Tiếp tục
          <v-icon>navigate_next</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import validate from '@/utils/validate';
import { mapActions, mapMutations, mapGetters } from 'vuex';
import moment, { months } from 'moment';
import * as DateTimeUtil from '@/utils/datetime';

export default {
  data: () => ({
    activeStep: 1,
    isLoading: false,
    validate: validate,
    moment: moment,
    maintenanceType: [],
    display: {
      typeNameInput: false,
      lastExecutionInput: false,
      lastExecutionMenu: false
    },
    error: {
      inputName: '',
      lastExecutionDate: ''
    },
    form: {
      isValid: false,
      vehicleId: '',
      name: '',
      inputName: '',
      kmInterval: 3000,
      kmRemain: 0,
      monthInterval: 3,
      nextMaintenanceDate: '',
      dayInterval: 90,
      kmBased: true,
      dayBased: true,
      lastExecution: 0,
      lastExecutionMonth: 1,
      lastExecutionDate: moment().format('YYYY-MM-DD'),
      remark: ''
    }
  }),
  computed: {
    ...mapGetters(['vehicles']),
    currentTitle () {
      switch (this.activeStep) {
        case 1:
          return 'Chọn xe';
        case 2:
          return 'Loại bảo trì';
        case 3:
          return 'Phương thức bảo trì';
        case 4:
          return 'Lần bảo trì gần nhất';
        case 5:
          return 'Kiểm tra thông tin';
      }
    }
  },
  watch: {
    'form.vehicleId' () {
      this.getMaintenanceTypeByVehicle();
    },
    'form.name' () {
      this.display.typeNameInput = this.form.name === 'empty';
    },
    'form.lastExecutionMonth' () {
      this.display.lastExecutionInput = this.form.lastExecutionMonth === -1;
      if (this.display.lastExecutionInput) {
        this.calcLastExecution(this.form.lastExecutionDate);
      } else {
        this.calcLastExecution();
      }
    },
    'form.lastExecutionDate' () {
      this.display.lastExecutionInput = this.form.lastExecutionMonth === -1;
      this.calcLastExecution(this.form.lastExecutionDate);
    },
    'form.monthInterval' () {
      if (this.display.lastExecutionInput) {
        this.calcLastExecution(this.form.lastExecutionDate);
      } else {
        this.calcLastExecution();
      }
    }
  },
  created () {
    if (this.vehicles.length === 0) {
      this.getVehicles().then(vehicles => {
        if (vehicles.length > 0) {
          this.form.vehicleId = vehicles[0].id;
        }
        return 0;
      });
    } else {
      this.form.vehicleId = this.vehicles[0].id;
    }
    this.calcLastExecution();
  },
  methods: {
    ...mapActions([
      'getVehicles',
      'getMaintenanceTypes',
      'getMaintenances',
      'calculateKmRemain',
      'createMaintenance'
    ]),
    ...mapMutations(['ADD_MAINTENANCE']),

    getMaintenanceTypeByVehicle () {
      this.getMaintenanceTypes({
        vehicleId: this.form.vehicleId,
        isVietnamese: true
      }).then(res => {
        this.maintenanceType = res;
        this.form.name = res[0];
      });
    },

    calcLastExecution (date) {
      if (date) {
        this.form.lastExecution = DateTimeUtil.convertDateTimeToSecond2010(
          date
        );
        this.form.nextMaintenanceDate = moment(date)
          .add(this.form.monthInterval, 'months')
          .format('YYYY-MM-DD');
      } else {
        let d = moment().add(-(this.form.lastExecutionMonth * 30), 'days');
        this.form.lastExecution = DateTimeUtil.convertDateTimeToSecond2010(d);
        this.form.nextMaintenanceDate = d
          .add(this.form.monthInterval, 'months')
          .format('YYYY-MM-DD');
      }
    },

    next () {
      if (this.activeStep === 2) {
        if (this.form.name === 'empty' && this.form.inputName === '') {
          this.error.inputName = 'Không được để trống trường này';
        } else {
          this.error.inputName = '';
          this.activeStep++;
        }
      } else if (this.activeStep === 4) {
        if (
          this.form.lastExecutionMonth === -1 &&
          this.form.lastExecutionDate === ''
        ) {
          this.error.lastExecutionDate = 'Không được để trống trường này';
        } else {
          if (this.form.kmBased) {
            let params = {
              time: this.form.lastExecution,
              kmInterval: this.form.kmInterval,
              vehicleId: this.form.vehicleId
            };
            this.calculateKmRemain(params).then(res => {
              this.form.kmRemain = res;
            });
          }
          this.error.lastExecutionDate = '';
          this.activeStep++;
        }
      } else if (this.activeStep === 5) {
        this.submit();
      } else {
        this.activeStep++;
      }
    },

    submit () {
      this.isLoading = true;
      if (this.form.inputName) {
        this.form.name = this.form.inputName;
      }

      this.createMaintenance(this.form)
        .then(res => {
          this.isLoading = false;
          this.getMaintenances();
          this.activeStep = 1;
          this.$emit('show', false);
          window.getApp.showMessage('Tạo lịch bảo trì thành công');
        })
        .catch(_ => {
          this.isLoading = false;
          window.getApp.showMessage('Tạo thất bại, vui lòng thử lại', 'error');
        });
    }
  }
};
</script>
<style scoped lang="css">
.form {
  min-height: 200px;
}
p {
  text-align: left;
}
.window-content {
  padding: 16px 32px 16px 32px;
}
.window-title {
  margin-left: 16px;
}
.min-top {
  margin-top: -16px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/maintenance/components/Add.vue